var _rect, _circle, _circle2, _path, _line;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVacanciesFilter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 24,
    viewBox: "0 0 41 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 40,
    height: 24,
    rx: 12,
    fill: "var(--icon-pill-bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10.5,
    r: 6,
    stroke: "var(--icon-pill-muted)"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 10.5,
    r: 4.5,
    fill: "var(--icon-pill-muted)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18.7891 10 19.4286 9.32852 19.4286 8.5C19.4286 7.67148 18.7891 7 18 7C17.2109 7 16.5714 7.67148 16.5714 8.5C16.5714 9.32852 17.2109 10 18 10ZM19 10.375H18.8136C18.5658 10.4945 18.2902 10.5625 18 10.5625C17.7098 10.5625 17.4353 10.4945 17.1864 10.375H17C16.1719 10.375 15.5 11.0805 15.5 11.95V12.4375C15.5 12.748 15.74 13 16.0357 13H19.9643C20.26 13 20.5 12.748 20.5 12.4375V11.95C20.5 11.0805 19.8281 10.375 19 10.375Z",
    fill: "var(--icon-pill-fg)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 23.2071,
    y1: 16,
    x2: 26.5,
    y2: 19.2929,
    stroke: "var(--icon-pill-muted)",
    strokeLinecap: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVacanciesFilter);
export default __webpack_public_path__ + "static/media/vacancies_filter.ec4c175f.svg";
export { ForwardRef as ReactComponent };